module.exports = __webpack_public_path__ + "img/nft2.0b2a6e09.jpg";